






























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { MediaComponentProps } from './VideoCallRoomContainer.vue'
import { Compact } from 'vue-color'

@Component({
  components: {
    VideoCallMainScreen: () => import('./VideoCallMainScreen.vue'),
    Drawing: () => import('@/components/drawing/Index.vue'),
    Compact
  }
})
export default class VideoCallRoomMinimum extends Vue {
  @Prop(Object) participant!: MediaComponentProps
  @Prop(Boolean) on!: boolean

  $store!: ExStore
  penType = 'pen' as 'pen' | 'highlight'
  selectColor = false

  get userFullName() {
    return `${this.participant.lastName}${this.participant.firstName}`
  }

  handleClickMaximizeButton() {
    this.$store.commit('drawing/clear')
    this.$store.commit('drawing/finishDrawing')
    this.$store.commit('videoCallRoom/minimized', false)
  }

  get brushColor() {
    return this.$store.state.drawing.color
  }

  setPencil() {
    this.penType = 'pen'
    this.$store.commit('drawing/setStroke', 5)
    this.$store.commit('drawing/setMode', 'source-over')
    this.$store.commit('drawing/setOpacity', 0.9)
  }

  setHighlight() {
    this.penType = 'highlight'
    this.$store.commit('drawing/setStroke', 20)
    this.$store.commit('drawing/setMode', 'source-over')
    this.$store.commit('drawing/setOpacity', 0.5)
  }
}
